import { getSupportCenterDomain } from '@va/dashboard/selectors/customization';
import { SwitchIcon } from '@va/icons';
import { useTranslate } from '@va/localization';
import { Button, fontWeights, Heading1 } from '@va/ui/design-system';
import { TooltipWrapper } from '@va/ui/tooltips';
import classNames from 'classnames';
import { FC } from 'react';
import { useSelector } from 'react-redux';

const InactiveFeatureCard: FC<{
  featureIcon: Function;
  featureTitle: string;
  featureKey: string;
  featureTooltip?: string;
  onActivateClick?: () => void;
}> = ({ featureIcon, featureTitle, featureKey, onActivateClick, featureTooltip }) => {
  const translate = useTranslate();
  const supportCenterDomain = useSelector(getSupportCenterDomain);
  return (
    <>
      <div className='flex flex-col h-full gap-3'>
        <div className='grow flex flex-col gap-4 lg:flex-row'>
          <div className='grow flex flex-col justify-between items-center bg-white-snow hover:bg-white-smoke p-4 rounded-18 feature-status-section'>
            <div className='feature-icon mb-2'>{featureIcon()}</div>
            <div className='feature-status-content flex flex-col justify-center items-center text-center'>
              <Heading1 colorClassName='text-gray-code ' className='' weight={fontWeights.semibold}>
                0
              </Heading1>
              <TooltipWrapper trigger='click' content={featureTooltip} disabled={!featureTooltip}>
                <div
                  className={classNames('text-lg leading-6 text-gray-charcoal font-semibold mt-[0.375rem] tracking-n0015', {
                    'border-b border-dashed border-gray-silver cursor-default': featureTooltip,
                  })}
                >
                  {featureTitle}
                </div>
              </TooltipWrapper>
            </div>
            <div className='feature-settings-content flex items-center w-full justify-between'>
              <Button
                onClick={() => {
                  window.open(translate(`featureCard.${featureKey}.learnMoreLink`, { supportCenterDomain }), '_blank');
                }}
                className='w-full'
                text={translate(`featureCard.${featureKey}.learnMore`)}
                color='tertiary'
              />
            </div>
          </div>
        </div>
      </div>
      <Button
        className='w-full shrink-0 justify-center'
        icon={(_, color) => <SwitchIcon color={color} />}
        text={translate('featureCard.activateFeature')}
        color='primary'
        onClick={onActivateClick}
      />
    </>
  );
};

export default InactiveFeatureCard;
